// Function to get the 'user_id' from sessionStorage.
// It retrieves the stored token value for use in requests or other logic.
export default function getUserId(): number | null {
  // Retrieve the 'user_id' from sessionStorage

  if (typeof window !== "undefined") {
    return Number(sessionStorage.getItem("user_id")) || null;
  }
  // Return the user_id value (or null if not found)

  return null;
}
